!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ur = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ur",
    pluralRuleFunction: function (e, t) {
      var r = !String(e).split(".")[1];
      return t ? "other" : 1 == e && r ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "سال",
        relative: {
          0: "اس سال",
          1: "اگلے سال",
          "-1": "گزشتہ سال"
        },
        relativeTime: {
          future: {
            one: "{0} سال میں",
            other: "{0} سال میں"
          },
          past: {
            one: "{0} سال پہلے",
            other: "{0} سال پہلے"
          }
        }
      },
      "year-short": {
        displayName: "سال",
        relative: {
          0: "اس سال",
          1: "اگلے سال",
          "-1": "گزشتہ سال"
        },
        relativeTime: {
          future: {
            one: "{0} سال میں",
            other: "{0} سال میں"
          },
          past: {
            one: "{0} سال پہلے",
            other: "{0} سال پہلے"
          }
        }
      },
      month: {
        displayName: "مہینہ",
        relative: {
          0: "اس مہینہ",
          1: "اگلا مہینہ",
          "-1": "پچھلا مہینہ"
        },
        relativeTime: {
          future: {
            one: "{0} مہینہ میں",
            other: "{0} مہینے میں"
          },
          past: {
            one: "{0} مہینہ پہلے",
            other: "{0} مہینے پہلے"
          }
        }
      },
      "month-short": {
        displayName: "ماہ",
        relative: {
          0: "اس مہینہ",
          1: "اگلے مہینہ",
          "-1": "پچھلے مہینہ"
        },
        relativeTime: {
          future: {
            one: "{0} ماہ میں",
            other: "{0} ماہ میں"
          },
          past: {
            one: "{0} ماہ قبل",
            other: "{0} ماہ قبل"
          }
        }
      },
      day: {
        displayName: "دن",
        relative: {
          0: "آج",
          1: "آئندہ کل",
          2: "آنے والا پرسوں",
          "-2": "گزشتہ پرسوں",
          "-1": "گزشتہ کل"
        },
        relativeTime: {
          future: {
            one: "{0} دن میں",
            other: "{0} دنوں میں"
          },
          past: {
            one: "{0} دن پہلے",
            other: "{0} دنوں پہلے"
          }
        }
      },
      "day-short": {
        displayName: "دن",
        relative: {
          0: "آج",
          1: "آئندہ کل",
          2: "آنے والا پرسوں",
          "-2": "گزشتہ پرسوں",
          "-1": "گزشتہ کل"
        },
        relativeTime: {
          future: {
            one: "{0} دن میں",
            other: "{0} دنوں میں"
          },
          past: {
            one: "{0} دن پہلے",
            other: "{0} دنوں پہلے"
          }
        }
      },
      hour: {
        displayName: "گھنٹہ",
        relative: {
          0: "اس گھنٹے"
        },
        relativeTime: {
          future: {
            one: "{0} گھنٹے میں",
            other: "{0} گھنٹے میں"
          },
          past: {
            one: "{0} گھنٹہ پہلے",
            other: "{0} گھنٹے پہلے"
          }
        }
      },
      "hour-short": {
        displayName: "گھنٹہ",
        relative: {
          0: "اس گھنٹے"
        },
        relativeTime: {
          future: {
            one: "{0} گھنٹے میں",
            other: "{0} گھنٹے میں"
          },
          past: {
            one: "{0} گھنٹے پہلے",
            other: "{0} گھنٹے پہلے"
          }
        }
      },
      minute: {
        displayName: "منٹ",
        relative: {
          0: "اس منٹ"
        },
        relativeTime: {
          future: {
            one: "{0} منٹ میں",
            other: "{0} منٹ میں"
          },
          past: {
            one: "{0} منٹ پہلے",
            other: "{0} منٹ پہلے"
          }
        }
      },
      "minute-short": {
        displayName: "منٹ",
        relative: {
          0: "اس منٹ"
        },
        relativeTime: {
          future: {
            one: "{0} منٹ میں",
            other: "{0} منٹ میں"
          },
          past: {
            one: "{0} منٹ پہلے",
            other: "{0} منٹ پہلے"
          }
        }
      },
      second: {
        displayName: "سیکنڈ",
        relative: {
          0: "اب"
        },
        relativeTime: {
          future: {
            one: "{0} سیکنڈ میں",
            other: "{0} سیکنڈ میں"
          },
          past: {
            one: "{0} سیکنڈ پہلے",
            other: "{0} سیکنڈ پہلے"
          }
        }
      },
      "second-short": {
        displayName: "سیکنڈ",
        relative: {
          0: "اب"
        },
        relativeTime: {
          future: {
            one: "{0} سیکنڈ میں",
            other: "{0} سیکنڈ میں"
          },
          past: {
            one: "{0} سیکنڈ پہلے",
            other: "{0} سیکنڈ پہلے"
          }
        }
      }
    }
  }, {
    locale: "ur-IN",
    parentLocale: "ur",
    fields: {
      year: {
        displayName: "سال",
        relative: {
          0: "اس سال",
          1: "اگلے سال",
          "-1": "گزشتہ سال"
        },
        relativeTime: {
          future: {
            one: "{0} سال میں",
            other: "{0} سالوں میں"
          },
          past: {
            one: "{0} سال پہلے",
            other: "{0} سال پہلے"
          }
        }
      },
      "year-short": {
        displayName: "سال",
        relative: {
          0: "اس سال",
          1: "اگلے سال",
          "-1": "گزشتہ سال"
        },
        relativeTime: {
          future: {
            one: "{0} سال میں",
            other: "{0} سالوں میں"
          },
          past: {
            one: "{0} سال پہلے",
            other: "{0} سالوں پہلے"
          }
        }
      },
      month: {
        displayName: "مہینہ",
        relative: {
          0: "اس ماہ",
          1: "اگلے ماہ",
          "-1": "گزشتہ ماہ"
        },
        relativeTime: {
          future: {
            one: "{0} ماہ میں",
            other: "{0} ماہ میں"
          },
          past: {
            one: "{0} ماہ قبل",
            other: "{0} ماہ قبل"
          }
        }
      },
      "month-short": {
        displayName: "مہینہ",
        relative: {
          0: "اس مہینہ",
          1: "اگلے مہینہ",
          "-1": "پچھلے مہینہ"
        },
        relativeTime: {
          future: {
            one: "{0} ماہ میں",
            other: "{0} ماہ میں"
          },
          past: {
            one: "{0} ماہ قبل",
            other: "{0} ماہ قبل"
          }
        }
      },
      day: {
        displayName: "دن",
        relative: {
          0: "آج",
          1: "آئندہ کل",
          2: "آنے والا پرسوں",
          "-2": "گزشتہ پرسوں",
          "-1": "گزشتہ کل"
        },
        relativeTime: {
          future: {
            one: "{0} دن میں",
            other: "{0} دنوں میں"
          },
          past: {
            one: "{0} دن پہلے",
            other: "{0} دنوں پہلے"
          }
        }
      },
      "day-short": {
        displayName: "دن",
        relative: {
          0: "آج",
          1: "آئندہ کل",
          2: "آنے والا پرسوں",
          "-2": "گزشتہ پرسوں",
          "-1": "گزشتہ کل"
        },
        relativeTime: {
          future: {
            one: "{0} دنوں میں",
            other: "{0} دنوں میں"
          },
          past: {
            one: "{0} دن پہلے",
            other: "{0} دنوں پہلے"
          }
        }
      },
      hour: {
        displayName: "گھنٹہ",
        relative: {
          0: "اس گھنٹے"
        },
        relativeTime: {
          future: {
            one: "{0} گھنٹے میں",
            other: "{0} گھنٹے میں"
          },
          past: {
            one: "{0} گھنٹہ پہلے",
            other: "{0} گھنٹے پہلے"
          }
        }
      },
      "hour-short": {
        displayName: "گھنٹہ",
        relative: {
          0: "اس گھنٹے"
        },
        relativeTime: {
          future: {
            one: "{0} گھنٹے میں",
            other: "{0} گھنٹے میں"
          },
          past: {
            one: "{0} گھنٹے قبل",
            other: "{0} گھنٹے قبل"
          }
        }
      },
      minute: {
        displayName: "منٹ",
        relative: {
          0: "اس منٹ"
        },
        relativeTime: {
          future: {
            one: "{0} منٹ میں",
            other: "{0} منٹ میں"
          },
          past: {
            one: "{0} منٹ قبل",
            other: "{0} منٹ قبل"
          }
        }
      },
      "minute-short": {
        displayName: "منٹ",
        relative: {
          0: "اس منٹ"
        },
        relativeTime: {
          future: {
            one: "{0} منٹ میں",
            other: "{0} منٹ میں"
          },
          past: {
            one: "{0} منٹ قبل",
            other: "{0} منٹ قبل"
          }
        }
      },
      second: {
        displayName: "سیکنڈ",
        relative: {
          0: "اب"
        },
        relativeTime: {
          future: {
            one: "{0} سیکنڈ میں",
            other: "{0} سیکنڈ میں"
          },
          past: {
            one: "{0} سیکنڈ قبل",
            other: "{0} سیکنڈ قبل"
          }
        }
      },
      "second-short": {
        displayName: "سیکنڈ",
        relative: {
          0: "اب"
        },
        relativeTime: {
          future: {
            one: "{0} سیکنڈ میں",
            other: "{0} سیکنڈ میں"
          },
          past: {
            one: "{0} سیکنڈ قبل",
            other: "{0} سیکنڈ قبل"
          }
        }
      }
    }
  }];
});